import * as React from 'react';
import {observer} from "mobx-react-lite";
import {Country} from "../../models/stats";
import {WorstCountryStore} from "../../stores/stats";
import {Carousel, Col, Row} from "react-bootstrap";
import Backdrop from "../Backdrop";


const WorstCountry = observer(function WorstCountry(props: {
    store: WorstCountryStore
}) {
    const {store} = props
    return <>
        {store.error ? store.error : ''}
        <Backdrop hidden={!store.loading} />

        <WorstCountryList items={store.data} />

        <Carousel.Caption>
            <h3>Most Active Countries</h3>
            <p>Countries with a high rate of malicious addresses observed in the last 24 hours</p>
        </Carousel.Caption>
    </>
});

const WorstCountryList = observer(function WorstCountryList(props: {items: Country[]}) {
    return <div className="stats-data justify-content-center">
        {props.items.map((e) => <WorstCountryView item={e} key={e.id} />)}
    </div>
})

const WorstCountryView = observer(function WorstCountryView(props: {item: Country}) {
    const {item} = props
    return <Row>
        <Col className="text-right">{item.country}</Col>
        <Col className="text-left">{item.percentage}</Col>
    </Row>
})

export default WorstCountry